module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/faceMask_c2029c.png";